module.exports = __webpack_public_path__ + "img/message_logo.1e475855.png";